import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState, useContext } from 'react';
import apiService from "../../service/apiService";
import { Button } from 'primereact/button';
import { RTLContext } from '../../App';
import StatusBadge from './StatusBadge';
import * as XLSX from "xlsx";
import { dateFormatter } from "../../utilities/utillFunction";
import { Calendar } from "primereact/calendar";
import moment from "moment";

const PaymentDetailsComponent = ({ paymentId }) => {
    const serviceId = "imaginehome_master_db";
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [paymentDetails, setPaymentDetails] = useState({});
    const { closeSidebar } = useContext(RTLContext);

    const query = {
        filter: { "orderId": paymentId }
    };
    const getStatusBadge = (status) => {
        const statusConfig = {
            "Success": { label: "Accepted", color: "#10B981", bgColor: "#D1FAE5" },
            "Processing": { label: "Pending", color: "#F59E0B", bgColor: "#FEF3C7" },
            "Failed": { label: "Declined", color: "#EF4444", bgColor: "#FEE2E2" }
        };

        const config = statusConfig[status] || { label: status, color: "#6B7280", bgColor: "#F3F4F6" };

        return (
            <span style={{
                padding: "8px 18px",
                borderRadius: "16px",
                fontSize: "12px",
                fontWeight: "510",
                color: config.color,
                fontFamily: "Inter",
                backgroundColor: config.bgColor
            }}>
                {config.label}
            </span>
        );
    };

    const getData = async () => {
        try {
            let result = await apiService.httpDBService(
                query,
                serviceId,
                "nq-payment-transactions" // Replace with your actual collection name
            );

            if (result?.length) {
                setPaymentDetails(result[0]);
            }
        } catch (err) {
            setError("Something went wrong while fetching payment details.");
        } finally {
            setLoading(false);
        }
    };
    const onDownload = () => {
        const result = Array.isArray(paymentDetails) ? paymentDetails : [paymentDetails];
        const exportData = result.map(item => ({
            "Payment ID": item.orderId || "",
            "Date": dateFormatter(item.created_at, "M/D/YY", "YYYY-MM-DD HH:mm:ss"),
            "Client Name": item.payee?.customerName || item.payee?.name || item.email || "",
            "Client ID": item.payee?.customer || "",
            "Email": item.email || "",
            "Payment Method": item.paymentMethod || "",
            "Payment Gateway": item.paymentGateway || "",
            "Amount": item.amount ? Number(item.amount).toFixed(2) : "0.00",
            "Currency": item.currency || "",
            "Status": item.status || "",
            "Merchant ID": item.merchantId || "",
            "Merchant Name": item.merchantName || "",
            "Surcharge Fee": item.surcharge_fee ? Number(item.surcharge_fee).toFixed(2) : "0.00",
            "Response Text": item.response?.resptext || "",
            "Response Amount": item.response?.amount || "",
            "Ref ID": item.retref || "",
            "Token": item.token || "",
        }));

        const fileName = `payments_${moment().format("YYYY-MM-DD")}.xlsx`;

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

        XLSX.writeFile(workbook, fileName);
    };

    useEffect(() => {
        setError("");
        setLoading(true);
        setPaymentDetails({});
        getData();
    }, [paymentId]);

    const getPaymentMethod = () => {
        const method = paymentDetails?.paymentMethod?.toUpperCase();
        const last4 = paymentDetails?.token?.substring(paymentDetails?.token?.length - 4);
        return `${method}`;
    };

    const formatCurrency = (value) => {
        if (value == null || value === "") return "$0.00";
        return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const getPaymentIdDisplay = () => {
        return `#${paymentDetails?.orderId?.substring(0, 4) || paymentDetails?._id?.substring(20) || '0000'}`;
    };

    const handleExportPaymentDetails = () => {
        // Implementation for exporting payment details
        console.log("Export Payment Details clicked");
    };

    const handleEmailPaymentConfirmation = () => {
        // Implementation for emailing payment confirmation
        console.log("Email Payment Confirmation clicked");
    };

    if (loading) return (
        <div className='grid justify-content-center align-items-center mt-4'>
            <ProgressSpinner style={{ width: '50px', height: '50px', display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }} />
        </div>
    );

    if (error.length) return <p>{error}</p>;

    return (
        <div className="mt-2 p-1">
            {/* Header */}
            <div className='flex justify-content-between align-items-center mb-1 lg:p-3 p-4'>
                <div className='flex align-items-center gap-2'>
                    <h2 className='m-0' style={{
                        fontFamily: "Inter",
                        fontSize: '20px',
                        fontWeight: '700',
                        color: "black"
                    }}>
                        Payment {getPaymentIdDisplay()}
                    </h2>
                    <div className='ml-2'>{getStatusBadge(paymentDetails["status"])} </div>
                </div>
                <Button
                    icon="pi pi-times"
                    className="p-button-text p-button-rounded"
                    style={{ color: "black" }}
                    onClick={closeSidebar}
                    aria-label="Close"
                />
            </div>

            {/* Customer Info Card */}
            <div style={{

                borderRadius: "8px",
                padding: "20px",
                marginBottom: "20px"
            }}>
                <div className="grid ">
                    <div className="lg:col-6 col-12">
                        <div className="mb-3">
                            <div className='item-details-dialog-header'>
                                Name
                            </div>
                            <div className='item-details-dialog-body'>
                                {paymentDetails?.payee?.name || paymentDetails?.payee?.customerName || "N/A"}
                            </div>
                        </div>
                        <div className="mb-3">
                            <div className='item-details-dialog-header'>
                                Phone Number
                            </div>
                            <div className='item-details-dialog-body'>
                                {paymentDetails?.payee?.phone || paymentDetails?.payee?.customerPhone || "N/A"}
                            </div>
                        </div>
                        <div className='item-details-dialog-header'>
                            <div className='item-details-dialog-header'>
                                Payment Method
                            </div>
                            <div className='item-details-dialog-body'>
                                {getPaymentMethod() ?? "N/A"}
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className='item-details-dialog-header'>
                                Email Address
                            </div>
                            <div className='item-details-dialog-body'>
                                {paymentDetails?.email || paymentDetails?.payee?.email || "N/A"}
                            </div>
                        </div>
                        <div className="">
                            <div className='item-details-dialog-header'>
                                Billing Address
                            </div>
                            <div className='item-details-dialog-body'>
                                {paymentDetails?.payee?.postal || "N/A"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="lg:col-6 col-12 mb-4 p-0 lg:ml-2">
                <Button

                    label="Export Payment Details"
                    onClick={onDownload}
                    style={{
                        background: "white",
                        height: "40px",
                        boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                        border: "1px solid #ddd",
                        color: "#3d3d3d",
                        borderRadius: "10px",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                        fontFamily: "Inter"
                    }}
                    className="p-button-outlined col-12 "
                />
            </div>

            {/* Action Buttons */}
            {/* <div className="grid mb-4">
                <div className="col-6">
                    <Button 
                        label="Export Payment Details"
                        className="w-full"
                        style={{
                            background: "#fff",
                            border: "1px solid #D1D5DB",
                            color: "#111827",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            fontWeight: "500"
                        }}
                        onClick={handleExportPaymentDetails}
                    />
                </div>
                <div className="col-6">
                    <Button 
                        label="Email Payment Confirmation"
                        className="w-full"
                        style={{
                            background: "#fff",
                            border: "1px solid #D1D5DB",
                            color: "#111827",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            fontWeight: "500"
                        }}
                        onClick={handleEmailPaymentConfirmation}
                    />
                </div>
            </div> */}

            {/* Payment Details Section */}
            <div className='p-3 mt-1'>
                <h3 style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#111827",
                    marginBottom: "16px"
                }}>
                    Payment Details
                </h3>

                <div className="mt-2">
                    <div className='item-details-dialog-header'>
                        Paid To
                    </div>
                    <div className='item-details-dialog-body'>
                        {paymentDetails?.merchantName || "N/A"}
                    </div>
                </div>

                <div className="grid mt-2">
                    <div className="col-6">
                        <div className='item-details-dialog-header'>
                            Amount Paid
                        </div>
                        <div className='item-details-dialog-body'>
                            {formatCurrency(paymentDetails?.amount) ?? "N/A"}
                        </div>
                    </div>

                </div>

                {/* <div className="mb-4">
                    <div  className='item-details-dialog-header'>
                        Transaction ID
                    </div>
                    <div className='item-details-dialog-body'>
                        {paymentDetails?.retref || paymentDetails?.orderId || "N/A"}
                    </div>
                </div> */}

                <div className="mt-2">
                    <div className='item-details-dialog-header'>
                        Merchant ID
                    </div>
                    <div className='item-details-dialog-body'>
                        {paymentDetails?.merchantId || "N/A"}
                    </div>
                </div>

                {/* {paymentDetails?.error && (
                    <div className="mb-4">
                        <div style={{ fontWeight: "600", fontSize: "12px", color: "#DC2626", marginBottom: "4px" }}>
                            Error
                        </div>
                        <div style={{ fontSize: "14px", color: "#DC2626" }}>
                            {paymentDetails.error}
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default PaymentDetailsComponent;